export default __webpack_public_path__ + "static/media/gilbert.1cda14e9.webp";